/** @format */

import {styled} from '@mui/material/styles';
import {Box} from '@mui/material';

const PREFIX = 'Grouping';

export const classes = {
  headerTitle: `${PREFIX}-headerTitle`,
  addButtonContainer: `${PREFIX}-addButtonContainer`,
  addButton: `${PREFIX}-addButton`,
  addButtonIcon: `${PREFIX}-addButtonIcon`,
  groupContainer: `${PREFIX}-groupContainer`,
  groupContainerEditMode: `${PREFIX}-groupContainerEditMode`,
  groupHeader: `${PREFIX}-groupHeader`,
  groupTitle: `${PREFIX}-groupTitle`,
  groupEditButton: `${PREFIX}-groupEditButton`,
  groupEditButtonIcon: `${PREFIX}-groupEditButtonIcon`,
  groupNameInput: `${PREFIX}-groupNameInput`,
  saveGroupEditButton: `${PREFIX}-saveGroupEditButton`,
  resetGroupEditButton: `${PREFIX}-resetGroupEditButton`,
  groupBody: `${PREFIX}-groupBody`,
  groupHeadingRow: `${PREFIX}-groupHeadingRow`,
  groupRow: `${PREFIX}-groupRow`,
  borderBottom: `${PREFIX}-borderBottom`,
  projectsAmount: `${PREFIX}-projectsAmount`,
  deleteFolderButton: `${PREFIX}-deleteFolderButton`,
  projectContainer: `${PREFIX}-projectContainer`,
  projectContainerEditable: `${PREFIX}-projectContainerEditable`,
  projectDeleteButton: `${PREFIX}-projectDeleteButton`,
  projectDeleteButtonIcon: `${PREFIX}-projectDeleteButtonIcon`,
  addProjectButton: `${PREFIX}-addProjectButton`,
  addProjectButtonIcon: `${PREFIX}-addProjectButtonIcon`,
};

export const Root = styled(Box)(({theme}) => ({
  [`& .${classes.headerTitle}`]: {
    color: '#F1F1F1',
    fontSize: '24px',
    fontWeight: 500,
    lineHeight: '26px',
    letterSpacing: '0.24px',
  },
  [`& .${classes.addButtonContainer}`]: {
    display: 'flex',
    justifyContent: 'end',
  },
  [`& .${classes.addButton}`]: {
    minWidth: 'auto',
    height: '50px',
    fontSize: '14px',
    fontWeight: 400,
    boxShadow: 'none',
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(2),
    },
  },

  [`& .${classes.addButtonIcon}`]: {
    fontSize: '18px',
  },

  [`& .${classes.groupContainer}`]: {
    marginBottom: theme.spacing(4),
    borderRadius: '16px',
    background: '#202020',
    boxShadow: '1px 1px 5px 0px rgba(0, 0, 0, 0.05)',
    border: '1px solid transparent',
  },
  [`& .${classes.groupContainerEditMode}`]: {
    borderColor: '#F1F1F1',
  },
  [`& .${classes.groupHeader}`]: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(5, 6),
  },
  [`& .${classes.groupTitle}`]: {
    color: '#F1F1F1',
    fontSize: '20px',
    fontWeight: 500,
    lineHeight: '22px',
    letterSpacing: '0.2px',
  },
  [`& .${classes.groupEditButton}`]: {
    width: '48px',
    height: '48px',
    display: 'flex',
    alignItems: 'center',
  },
  [`& .${classes.groupEditButtonIcon}`]: {
    color: '#8B8B8B',
    fontSize: '16px',
  },

  [`& .${classes.groupNameInput}`]: {
    width: '50%',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  [`& .${classes.saveGroupEditButton}`]: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      width: '100%',
      marginTop: theme.spacing(2),
    },
  },
  [`& .${classes.resetGroupEditButton}`]: {
    height: '48px',
    marginLeft: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      width: '100%',
      marginTop: theme.spacing(2),
    },
  },

  [`& .${classes.groupBody}`]: {
    padding: theme.spacing(0, 6, 6, 6),
  },

  [`& .${classes.groupHeadingRow}`]: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBottom: theme.spacing(2),
    color: '#8B8B8B',
    fontSize: '14px',
    fontWeight: 700,
    lineHeight: '16px',
    letterSpacing: '0.28px',
    '& > div': {
      width: '50%',
    },
    [theme.breakpoints.down('md')]: {
      '& > div': {
        width: '100%',
      },
    },
  },

  [`& .${classes.groupRow}`]: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    padding: theme.spacing(2, 0, 4, 0),
    color: '#F1F1F1',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '20px',
    '& > div': {
      width: '50%',
      paddingRight: theme.spacing(4),
    },
    [theme.breakpoints.down('md')]: {
      '& > div': {
        width: '100%',
      },
    },
  },
  [`& .${classes.borderBottom}`]: {
    borderBottom: '1px solid #383838',
  },

  [`& .${classes.projectsAmount}`]: {
    marginTop: theme.spacing(2),
    color: '#8B8B8B',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '16px',
  },

  [`& .${classes.deleteFolderButton}`]: {
    height: '32px',
    marginTop: theme.spacing(6),
    borderRadius: '8px',
    background: '#EA5759',
    color: '#F1F1F1',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '16px',
  },

  [`& .${classes.projectContainer}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
    padding: theme.spacing(1),
    borderRadius: '8px',
    color: '#F1F1F1',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '16px',
  },
  [`& .${classes.projectContainerEditable}`]: {
    '&:hover': {
      background: '#4D4E4E',
      cursor: 'pointer',
    },
  },

  [`& .${classes.projectDeleteButton}`]: {
    width: '24px',
    minWidth: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
  },
  [`& .${classes.projectDeleteButtonIcon}`]: {
    color: '#8B8B8B',
    fontSize: '16px',
  },

  [`& .${classes.addProjectButton}`]: {
    marginTop: theme.spacing(4),
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    color: '#8B8B8B',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '16px',
  },
  [`& .${classes.addProjectButtonIcon}`]: {
    marginRight: theme.spacing(2),
    color: '#8B8B8B',
    fontSize: '16px',
  },
}));
